// AI Sparkles Icon - squircle background with cutout sparkles
interface AISparklesIconProps {
    size?: number;
    bgColor?: string;
    starColor?: string;
}

export const AISparklesIcon = ({ size = 14, bgColor = '#667eea', starColor = 'white' }: AISparklesIconProps) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect width="24" height="24" rx="6" fill={bgColor} />
        <path d="M9.5 2L10.5 5.5L14 6.5L10.5 7.5L9.5 11L8.5 7.5L5 6.5L8.5 5.5L9.5 2Z" fill={starColor} />
        <path d="M17 8L18.5 13L23 14.5L18.5 16L17 21L15.5 16L11 14.5L15.5 13L17 8Z" fill={starColor} />
        <path d="M6 14L7 17L10 18L7 19L6 22L5 19L2 18L5 17L6 14Z" fill={starColor} />
    </svg>
);

export default AISparklesIcon;
